import { useEffect, useMemo, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"

import {
  getMessageTemplatesOld,
  useLazyEditMessageTemplateOldQuery,
  useLazyGetMessageTemplatesOldQuery,
} from "store/api/contractorsApi"
import { useAppSelector } from "store/hooks"
import { ApiTypes, UITypes } from "types"

import getErrorMessage from "utils/getErrorMessage"
import { MessageForm } from "components/form/MessageFormOld"

import MessageTemplateContainer from "../MessageTemplateContainerOld/MessageTemplateContainer"

export const MessageTemplateEdit = () => {
  const [triggerEditMessageTemplate, { isFetching }] = useLazyEditMessageTemplateOldQuery()
  const [triggerGetMessageTemplates] = useLazyGetMessageTemplatesOldQuery()
  const [currentTemplate, setCurrentTemplate] = useState<ApiTypes.Model.MessageTemplateOld | null>(null)
  const [searchParams] = useSearchParams()
  const templateId = searchParams.get("id")
  const selectMessageTemplates = useMemo(() => getMessageTemplatesOld.select(), [])
  const messageTemplates = useAppSelector(selectMessageTemplates)
  const navigate = useNavigate()

  const transformEditData = useMemo((): UITypes.MessageTemplate | undefined => {
    if (!currentTemplate) return undefined

    return {
      title: currentTemplate.title,
      message: currentTemplate.body,
      message_rich: currentTemplate.body_rich,
      frequency: currentTemplate.repeat_every,
    }
  }, [currentTemplate])

  const onSetCurrentTemplate = () => {
    const templatesList = messageTemplates?.data?.data
    if (!templateId || !templatesList?.length) {
      setCurrentTemplate(null)
    } else {
      const currentTemplate = templatesList.filter(item => item.id === Number(templateId))[0]
      setCurrentTemplate(currentTemplate)
    }
  }

  const onEditTemplate = async (data: UITypes.MessageTemplate) => {
    try {
      const res = await triggerEditMessageTemplate({
        body: {
          title: data.title,
          body: data.message,
          body_rich: data.message_rich || "",
          repeat_every: data.frequency as ApiTypes.Model.MessageTemplateFrequency,
        },
        id: templateId!,
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
      } else {
        toast.success("Message template has been successfully updated!")
        navigate("/messages/create-template")
        triggerGetMessageTemplates()
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    onSetCurrentTemplate()
  }, [messageTemplates, templateId])

  return (
    <MessageTemplateContainer title="Edit message template">
      <MessageForm isLoading={isFetching} onSave={onEditTemplate} editableTemplate={transformEditData} />
    </MessageTemplateContainer>
  )
}
